import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import VolumePricingManager from '../components/VolumePricingManager';

export default function MyProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch('/api/products/my-products', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setProducts(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (loading) return <div className="text-center py-8">Loading your products...</div>;
  if (error) return <div className="text-center py-8 text-red-600">Error: {error}</div>;
  if (products.length === 0) return <div className="text-center py-8">No products yet. <Link to="/add-product" className="text-green-600">Add your first product</Link></div>;

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">My Products</h1>
        <Link to="/add-product" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">Add Product</Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map(product => (
          <div key={product._id} className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img 
                src={product.images?.[0] ? `/uploads/${product.images[0]}` : '/placeholder.jpg'} 
                alt={product.name} 
                className="w-full h-full object-cover" 
              />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-lg mb-2">{product.name}</h3>
              <p className="text-gray-600 text-sm mb-2">{product.description}</p>
              <p className="text-green-600 font-bold mb-4">${product.price}/{product.unit}</p>
              
              {/* Volume Pricing Section */}
              <div className="border-t pt-3 mb-3">
                <VolumePricingManager 
                  productId={product._id} 
                  productName={product.name}
                  onUpdate={() => {
                    // Refresh product list if needed
                  }}
                />
              </div>
              
              <div className="flex justify-between">
                <Link to={`/edit-product/${product._id}`} className="text-blue-600 hover:underline">Edit</Link>
                <button onClick={async () => {
                  if (window.confirm('Delete this product?')) {
                    await fetch(`/api/products/${product._id}`, {
                      method: 'DELETE',
                      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                    });
                    setProducts(products.filter(p => p._id !== product._id));
                  }
                }} className="text-red-600 hover:underline">Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
